"use client";

import { RoundButtonLink } from "cy-ui/components/RoundIcons";
import { ArrowLeftIcon } from "lucide-react";
import { HeaderOverrideContent } from "./HeaderContentOverride";

export function HeaderWithBackButton({ href }: { href: string }) {
  return (
    <HeaderOverrideContent>
      <div>
        <RoundButtonLink href={href} icon={ArrowLeftIcon} />
      </div>
    </HeaderOverrideContent>
  );
}
